import type { CSSObject, Theme } from '@mui/material/styles';

import { varAlpha } from 'minimal-shared/utils';

/**
 * Subtle 1px inset outline for content images and avatars. Pure black on light,
 * pure white on dark — never a tinted neutral, which would pick up the surface
 * colour and read as dirt on the image edge. `outline-offset: -1px` keeps it
 * inset so the image stays its intended size. Modern browsers render `outline`
 * following `border-radius`, so this works on rounded/circular images too.
 */
export function imageOutlineSx(theme: Theme): CSSObject {
  return {
    outline: `1px solid ${varAlpha(theme.palette.common.blackChannel, 0.1)}`,
    outlineOffset: '-1px',
    ...theme.applyStyles('dark', {
      outline: `1px solid ${varAlpha(theme.palette.common.whiteChannel, 0.1)}`,
    }),
  } as const;
}
